import { Company } from "@/types";

export interface ICompanyState {
  company: Company | null;
  companies: Company[] | null;
  dataProvider: Company[];
  companyIdActive: string | null;
}

export const state: ICompanyState = {
  company: null,
  companies: null,
  dataProvider: [],
  companyIdActive: null,
};

export enum CompanyTypesEnum {
  LEGAL = "LEGAL",
  INDIVIDUAL = "INDIVIDUAL",
}
